/**
 * 判断是否为空
 * @param {*} val
 */
export function isNullValue(value) {
  if (['null', null, 'undefined', undefined, ''].includes(value)) {
    return true
  }
  if (typeof val === 'boolean') {
    return false
  }
  if (typeof val === 'number') {
    return false
  }
  if (value instanceof Array) {
    if (value.length === 0) return true
  } else if (value instanceof Object) {
    if (JSON.stringify(value) === '{}') return true
  }
  return false
}
/**
 * 递归将 children 转成tasks
 * @param {*} list
 */
export const tasksEvent = (list = [], second = null, level = 1) => {
  let item = second
  if (isNullValue(list)) return []
  for (let index = 0; index < list.length; index++) {
    const element = list[index]
    element['show'] = true
    element['selected'] = false
    element['level'] = level
    element['expanded'] = true
    if (level === 1) item = element
    if (!isNullValue(element.targetId) && !isNullValue(item)) {
      element['secondNodeId'] = item.id
      element['secondNodeName'] = item.name
    }
    element.children = tasksEvent(element.children, item, level + 1)
  }
  return list
}

/**
 * 获取文件类型
 * @param url
 * @returns {{type: string, icon: string, key: number}}
 */
export function getFileType(url) {
  // 后缀获取
  let suffix = ''
  // 获取类型结果
  let result = ''
  try {
    const filesArr = url.split('.')
    suffix = filesArr[filesArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  // url无后缀
  if (!suffix) {
    // 其他 文件类型
    return { type: 'unknown', icon: 'file-other', key: 6 }
  }
  suffix = suffix.toLocaleLowerCase()
  // 匹配 image
  const imageList = ['png', 'jpg', 'svg', 'gif', 'jpeg', 'raw', 'bmp', 'tiff', 'webp']
  result = imageList.find((item) => item === suffix)
  if (result) {
    return { type: 'image', icon: 'file-image', key: 2 }
  }
  // 匹配 excel
  const excelList = ['xls', 'xlsx']
  result = excelList.find((item) => item === suffix)
  if (result) {
    return { type: 'excel', icon: 'file-excel', key: 1 }
  }
  // 匹配 word
  const wordList = ['doc', 'docx']
  result = wordList.find((item) => item === suffix)
  if (result) {
    return { type: 'word', icon: 'file-doc', key: 1 }
  }
  // 匹配 pdf
  const pdfList = ['pdf']
  result = pdfList.find((item) => item === suffix)
  if (result) {
    return { type: 'pdf', icon: 'file-pdf', key: 1 }
  }
  // 匹配 ppt
  const pptList = ['ppt', 'pptx']
  result = pptList.find((item) => item === suffix)
  if (result) {
    return { type: 'ppt', icon: 'file-ppt', key: 1 }
  }
  // 匹配 video
  const videoList = ['mp4', 'mpeg', 'avi', 'mov', 'flv', 'webm', 'mpg', '3gp', 'wmv']
  result = videoList.find((item) => item === suffix)
  if (result) {
    return { type: 'video', icon: 'file-video', key: 3 }
  }
  // 匹配 audio
  const audioList = ['mp3', 'mid', 'wav', 'm3u', 'm4a', 'ogg']
  result = audioList.find((item) => item === suffix)
  if (result) {
    return { type: 'audio', icon: 'file-audio', key: 4 }
  }
  // 匹配 压缩包
  const zipList = ['zip', 'rar', '7z']
  result = zipList.find((item) => item === suffix)
  if (result) {
    return { type: 'zip', icon: 'file-zip', key: 5 }
  }
  // 其他 文件类型
  return { type: 'other', icon: 'file-other', key: 6 }
}
